import { gql } from "@apollo/client";


export const SET_PAYMENT = gql`
mutation($orderid:ID!,$finalBillAmount:Float!){
	setPaymentActive(orderid:$orderid,finalBillAmount:$finalBillAmount)
  }
`